<template>
  <div
    class="columns is-marginless has-padding-50 has-padding-bottom-400 is-multiline"
  >
    <div class="column is-12">
      <card>
        <template slot="header">
          <p class="card-header-title">
            <strong>Promotions</strong>
          </p>
        </template>
        <template slot="body">
          <products-table />
        </template>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Promotions",
  components: {
    "products-table": () => import("@shared/promotions/_promotionsTable")
  }
};
</script>
